/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1CoachPayout
 */
export interface V1CoachPayout {
    /**
     *
     */
    id: string
    /**
     * Payout date, YYYY-MM-DD
     */
    period: string
    /**
     *
     */
    assetKind: string
    /**
     *
     */
    stars: number
    /**
     * pending | sending | paid | failed
     */
    status: string
    /**
     *
     */
    wallet: string
    /**
     * TON sent, in nanotons (0 until sent)
     */
    nanotons: number
    /**
     * TON price used for the conversion
     */
    tonUsd: number
    /**
     * Why a pending payout waits (e.g. no payout wallet)
     */
    error: string
    /**
     *
     */
    createdAt: number
    /**
     *
     */
    paidAt: number
}

/**
 * Check if a given object implements the V1CoachPayout interface.
 */
export function instanceOfV1CoachPayout(value: object): value is V1CoachPayout {
    if (!('id' in value) || value['id'] === undefined) return false
    if (!('period' in value) || value['period'] === undefined) return false
    if (!('assetKind' in value) || value['assetKind'] === undefined)
        return false
    if (!('stars' in value) || value['stars'] === undefined) return false
    if (!('status' in value) || value['status'] === undefined) return false
    if (!('wallet' in value) || value['wallet'] === undefined) return false
    if (!('nanotons' in value) || value['nanotons'] === undefined) return false
    if (!('tonUsd' in value) || value['tonUsd'] === undefined) return false
    if (!('error' in value) || value['error'] === undefined) return false
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false
    if (!('paidAt' in value) || value['paidAt'] === undefined) return false
    return true
}

export function V1CoachPayoutFromJSON(json: any): V1CoachPayout {
    return V1CoachPayoutFromJSONTyped(json, false)
}

export function V1CoachPayoutFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachPayout {
    if (json == null) {
        return json
    }
    return {
        id: json['id'],
        period: json['period'],
        assetKind: json['assetKind'],
        stars: json['stars'],
        status: json['status'],
        wallet: json['wallet'],
        nanotons: json['nanotons'],
        tonUsd: json['tonUsd'],
        error: json['error'],
        createdAt: json['createdAt'],
        paidAt: json['paidAt']
    }
}

export function V1CoachPayoutToJSON(json: any): V1CoachPayout {
    return V1CoachPayoutToJSONTyped(json, false)
}

export function V1CoachPayoutToJSONTyped(
    value?: V1CoachPayout | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        id: value['id'],
        period: value['period'],
        assetKind: value['assetKind'],
        stars: value['stars'],
        status: value['status'],
        wallet: value['wallet'],
        nanotons: value['nanotons'],
        tonUsd: value['tonUsd'],
        error: value['error'],
        createdAt: value['createdAt'],
        paidAt: value['paidAt']
    }
}
